var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11ZM9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12Z",
    fill: "#011235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24155 12.0596C5.08494 13.2581 6.17101 14.418 7.40184 15.3127C8.83709 16.3561 10.4131 17 12 17C13.5869 17 15.1629 16.3561 16.5982 15.3128C17.829 14.418 18.9151 13.2581 19.7585 12.0596C17.5457 9.37071 15.2328 7 12 7C8.76722 7 6.45433 9.37073 4.24155 12.0596ZM2.2225 11.3711C4.46246 8.60182 7.44262 5 12 5C16.5574 5 19.5376 8.60176 21.7775 11.3711C22.0469 11.7042 22.0742 12.1717 21.8456 12.5339C20.843 14.1216 19.4392 15.7201 17.7742 16.9305C16.1111 18.1394 14.1314 19 12 19C9.86862 19 7.8889 18.1394 6.22586 16.9305C4.56084 15.7201 3.15696 14.1216 2.15445 12.5339C1.92577 12.1717 1.95314 11.7041 2.2225 11.3711Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeVisible);
export default __webpack_public_path__ + "static/media/eye-visible.aa76875c60a8bd704cf40f327a9cc95e.svg";
export { ForwardRef as ReactComponent };